import BuildItemType from '../BuildItemType'
import dataImageCoverSrc from './data-integrations-cover.png'
import botCoverVideoSrc from './data-integrations-bot.mp4'

export const buildItemWidget = [
  {
    buildItemType: BuildItemType.BOT,
    name: 'Drift Bots',
    description: `Conversations are the building blocks of Drift - it only makes sense that you can build upon that! Using Drift conversation and messaging API's, you can create Drift apps that can assist live in Drift conversations, or collect data from them.`,
    coverVideoSrc: botCoverVideoSrc
  },
  {
    buildItemType: BuildItemType.DATA_INTEGRATION,
    name: 'Integrations and Beyond',
    description: `With integrations, you can send, receive, update and delete information from Drift: conversations, contacts, accounts, and more. Connect Drift apps with your account and start managing data how you want, when you want. `,
    coverImageSrc: dataImageCoverSrc
  }
]
